<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  class="drawer-desktop"
  (onHide)="closeDrawer()"
>
  <!-- HEADER -->
  <ng-template pTemplate="header">
    <div class="drawer-header">
      <div>
        <h3>SMS Alert Details</h3>
        <div class="sub-title">Recipients Alert Details</div>
      </div>
    </div>
  </ng-template>

  <!-- BODY -->
  <div class="drawer-body">
    <!-- Alert Message -->
    <div class="section">
      <h4>Alert Messages</h4>
      <p class="message">
        {{ smsDetails.message }}
      </p>
    </div>

    <!-- Time -->
    <div class="section">
      <h4>Time</h4>
      <p class="time">
        {{ TimeFormatterIso.format(smsDetails.time) || "N/A" }}
      </p>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <p-table
        [value]="smsDetails.recipients"
        [paginator]="true"
        [rows]="limit"
        [totalRecords]="totalRecords"
        [lazy]="true"
        [loading]="loading"
        (onLazyLoad)="onPageChange($event)"
        responsiveLayout="scroll"
        styleClass="sms-table"
      >
        <!-- HEADER -->
        <ng-template pTemplate="header">
          <tr>
            <th>Recipients</th>
            <th>Method</th>
            <th>Status</th>
            <th style="text-align: center">Action</th>
          </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-r>
          <tr>
            <td>
              <div class="recipient">
                <div class="avatar">
                  {{ InitialsUtils.getInitials(r.name) }}
                </div>
                <span>{{ r.name }}</span>
              </div>
            </td>

            <td>
              {{
                r.method === "SMS"
                  ? "SMS"
                  : StringUtils.snakeCaseToTitle(r.method)
              }}
            </td>

            <td>
              <span
                class="status"
                [class.failed]="r.status === AlertStatusEnum.FAILED"
                [class.delivered]="r.status === AlertStatusEnum.DELIVERED"
                [class.pending]="r.status === AlertStatusEnum.PENDING"
                [class.partial-delivered]="
                  r.status === AlertStatusEnum.PARTIAL_DELIVERED
                "
              >
                {{ StringUtils.snakeCaseToTitle(r.status) }}
              </span>
            </td>

            <td>
              <div class="d-flex justify-content-center">
                <ng-container *ngIf="r?.status !== 'DELIVERED'; else noAction">
                  <span (click)="resendAlert(r.id)">
                    <img
                      class="action-btn"
                      src="/images/icons/clock-02.svg"
                      width="18"
                      class="me-2"
                    />
                    <span>Send Again</span>
                  </span>
                </ng-container>

                <ng-template #noAction>
                  <span class="no-action-text">---</span>
                </ng-template>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="delete-overlays" *ngIf="isDeleteModalOpen">
    <div class="delete-container">
      <button class="close-btn" (click)="closeModal()">
        <img
          src="images/icons/cross.svg"
          alt="close"
          style="height: 24px; width: 24px"
        />
      </button>
      <i class="delete-icon" style="margin-bottom: 24px"
        ><img
          src="images/icons/red-delete.svg"
          alt=""
          style="height: 56px; width: 56px"
      /></i>

      <div class="delete-modal-body">
        <h2
          style="
            margin-bottom: 20px;
            font-weight: 600;
            font-size: 18px;
            color: var(--black-5);
            text-align: center;
            line-height: 1.3;
          "
        >
          Are you sure you want to delete this SMS Log ?
        </h2>
        <p
          style="
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 400;
            color: var(--balck-2);
            text-align: center;
          "
        >
          This action is permanent and can not be undone.
        </p>
      </div>
      <div class="delete-modal-footer">
        <button
          class="btn btn-secondary-cancel md"
          style="width: 120px; height: 56px"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary-delete md"
          style="width: 120px; height: 56px"
          (click)="deleteSingleAlert()"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</p-drawer>
